<template>

    <div class="panel panel-clinic">

        <div class="panel-heading collapsed" href="#product_prices" data-toggle="collapse">

            <div class="arrow-down"></div>

            <h2 class="panel-title">Priser</h2>

        </div>

        <div id="product_prices" class="panel-collapse collapse">

            <div class="panel-body">

                <p style="text-align: right">Visa bara aktiva försäljningskanaler <input type="checkbox" :value="true"
                                                                                         v-model="showOnlyActive"></p>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <div class="row">
                            <div class="col-md-13">Försäljningskanal</div>
                            <div class="col-md-11">Aktivt pris</div>
                            <div class="col-md-11">Aktivt kommentar</div>
                            <div class="col-md-9">Antal perioder</div>
                        </div>
                    </div>
                </div>

                <div class="panel panel-default" v-for="affiliate in filteredAffiliates">

                    <div class="panel-heading amounts collapsed" v-bind:href="'#item-'+affiliate.id"
                         data-toggle="collapse">

                        <div class="row">
                            <div class="col-md-13">{{ affiliate.name }}</div>
                            <div class="col-md-11"><span v-if="affiliate.active.price">{{
                                    affiliate.active.price
                                }} kr</span></div>
                            <div class="col-md-11">{{ affiliate.active.comment }}</div>
                            <div class="col-md-9">{{ affiliate.prices.length }}</div>
                            <div class="col-md-4 hidden-sm hidden-xs">
                                <button class="btn btn-sm btn-info" v-on:click.stop="openNewPrice(affiliate)">Nytt
                                    pris
                                </button>
                            </div>
                            <div class="arrow-down small"></div>
                        </div>

                    </div>

                    <div v-bind:id="'item-'+affiliate.id" class="collapse">

                        <div class="list-group" style="margin-bottom:0;">

                            <div class="list-group-item" style="background-color:#ebf7f6;"
                                 v-show="affiliate.newPrice.show">

                                <div class="row">

                                    <div class="col-md-1">

                                    </div>

                                    <div class="col-md-4">
                                        <div style="margin-top:4px;">Gäller från:</div>
                                    </div>
                                    <div class="col-md-8">
                                        <month-picker v-bind:value="affiliate.newPrice.valid_from"
                                                      v-on:changed="affiliate.newPrice.valid_from = arguments[0]"></month-picker>
                                    </div>

                                    <div class="col-md-11">
                                        <input type="text" class="form-control" v-model="affiliate.newPrice.price"
                                               placeholder="Pris i kr"/>
                                    </div>

                                    <div class="col-md-11">
                                        <input type="text" class="form-control" v-model="affiliate.newPrice.comment"
                                               placeholder="Kommentar, t ex kampanjnamn"/>
                                    </div>

                                    <div class="col-md-9">

                                    </div>

                                    <div class="col-md-4">
                                        <button class="btn btn-sm btn-default" v-on:click="save(affiliate.newPrice)">
                                            Lägg till
                                        </button>
                                    </div>

                                </div>

                            </div>

                            <div class="list-group-item" v-if="affiliate.prices.length == 0">

                                Inga priser

                            </div>

                            <div v-if="affiliate.prices != null" v-for="price in affiliate.prices">

                                <div class="list-group-item" style="background-color:#ebf7f6; border-top:none;"
                                     v-if="price.show">

                                    <div class="row">

                                        <div class="col-md-1">
                                        </div>

                                        <div class="col-md-12">
                                            <div style="margin-top:4px;">{{ price.priceFromStrMonth }}</div>
                                        </div>

                                        <div class="col-md-11">
                                            <input type="text" class="form-control" v-model="price.price"
                                                   placeholder="Pris i kr"/>
                                        </div>

                                        <div class="col-md-11">
                                            <input type="text" class="form-control" v-model="price.comment"
                                                   placeholder="Kommentar, t ex kampanjnamn"/>
                                        </div>

                                        <div class="col-md-9">

                                        </div>

                                        <div class="col-md-4">
                                            <button class="btn btn-sm btn-default" v-on:click="save(price)">Spara pris
                                            </button>
                                        </div>

                                    </div>

                                </div>

                                <div class="list-group-item" style="background-color:#fff; border-top:none;" v-else>

                                    <div class="row">

                                        <div class="col-md-1">
                                        </div>

                                        <div class="col-md-12">
                                            <div style="margin-top:4px;">{{ price.priceFromStrMonth }}</div>
                                        </div>

                                        <div class="col-md-11">
                                            <div style="margin-top:4px;">{{ price.price }}</div>
                                        </div>

                                        <div class="col-md-11">
                                            <div style="margin-top:4px;">{{ price.comment }}</div>
                                        </div>

                                        <div class="col-md-9">

                                        </div>

                                        <div class="col-md-4">
                                            <button class="btn btn-sm btn-info" v-if="!price.isAccounted"
                                                    v-on:click="price.show = true">Ändra pris
                                            </button>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

    </div>
</template>

<script>
export default {
    props: {
        product: {}
    },

    data: function () {
        return {
            affiliates: [],
            error: false,
            showOnlyActive: true
        }
    },

    created: function () {
        const self = this
        self.load()
    },

    computed: {

        filteredAffiliates () {
            let affiliates = this.affiliates

            if (this.showOnlyActive) {
                affiliates = affiliates.filter((affiliate) => {
                    return affiliate.is_active == true || affiliate.is_active_voucher == true
                })
            }

            return _.orderBy(affiliates, ['name'], ['asc'])
        }

    },

    methods: {

        load: function () {
            const self = this

            console.log('time to load affiliates')

            self.$http.post('/products/loadPrices', { product: self.product }).then((response) => {
                console.log(response.body)

                self.affiliates = response.body
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        },

        save: function (price) {
            const self = this

            if (price.price == null || price.price == '' || isNaN(price.price)) {
                alert('Priset får inte vara tomt och måste vara ett nummer.')

                return
            }

            self.$http.post('/products/savePrice', price).then((response) => {
                console.log(response.body)

                price.show = false

                if (!price.id) {
                    self.load()
                }
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        },

        openNewPrice: function (affiliate) {
            $('#item-' + affiliate.id).collapse('show')

            affiliate.newPrice.show = true
        }

    }

}
</script>
